// Simple component that can be used in both client and server components
export interface EnvironmentIndicatorProperties {
  label?: string | undefined;
  mode?: string | undefined;
}

export function EnvironmentIndicator(_properties: EnvironmentIndicatorProperties): null {
  return null;
}
